/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/
/** Drop staff handoff metadata, retaining room identification and invitation key. */
export function guestRoomLink(location: {
  pathname: string;
  search: string;
  hash: string;
}): string {
  const search = new URLSearchParams(location.search);
  search.delete("staffUser");
  search.delete("handoff");
  const index = location.hash.indexOf("?");
  let hash = location.hash;
  if (index >= 0) {
    const params = new URLSearchParams(hash.slice(index + 1));
    params.delete("handoff");
    params.delete("staffUser");
    hash = hash.slice(0, index) + "?" + params.toString();
  }
  return (
    location.pathname + (search.size ? "?" + search.toString() : "") + hash
  );
}
